import React from "react";
import { Link } from "react-router-dom";
import { SideBar } from "./../../sidebar";
import swal from "sweetalert";
import {
  getAuctionImages,
  uploadImage,
  getAuctionVideo,
  uploadVideo,
  removeImage,
  makeCover,
} from "../../../../models/auctions";
import { AuctionTabs } from "./../../helper/auction_tabs";
import { Spinner } from "react-bootstrap";
import i18n from "../../../../i18n";
import FileInput from "../../../helpers/fileInput";
import HeaderBanner from "../../../common/HeaderBanner";
import "../../../../styles/components/create-group.scss";
import {
  ArrowLeft,
  Cloud,
  Expand,
  Eye,
  Image,
  Loader2,
  Shrink,
  Star,
  Trash2,
  Video,
  X,
} from "lucide-react";

export class AuctionImage extends React.Component {
  constructor() {
    super();
    let path = window.location.pathname;
    let auctionId = path.substring(path.lastIndexOf("/") + 1, path.length);
    this.state = {
      auction: {},
      is_loading_video: false,
      is_loading_images: false,
      auctionId: auctionId,
      input: {},
      errors: {},
      videoFile: null,
      imageFiles: null,
      hideSidebar: false,
    };
    this.onFileChange = this.onFileChange.bind(this);
    this.uploadVideo = this.uploadVideo.bind(this);
    this.uploadImage = this.uploadImage.bind(this);
    this.removeImage = this.removeImage.bind(this);
    this.makeCover = this.makeCover.bind(this);
  }

  componentDidMount() {
    this.loadAllImages();
    this.loadVideo();
  }

  onFileChange = (event) => {
    if (event.target.name === "videoFile") {
      this.setState({ videoFile: event.target.files[0] });
    }
    if (event.target.name === "imageFiles") {
      this.setState({ imageFiles: event.target.files });
    }
  };

  async loadAllImages() {
    this.setState({ is_loading_images: true });
    const response = await getAuctionImages(this.state.auctionId);
    if (response) {
      let images = response.data;
      this.setState({ images });
      this.setState({ is_loading_images: false });
    }
  }

  async loadVideo() {
    this.setState({ is_loading_video: true });
    const response = await getAuctionVideo(this.state.auctionId);
    let auction = response.data;
    if (auction) {
      this.setState({ auction });
      this.setState({ is_loading_video: false });
    }
  }

  async uploadVideo(event) {
    event.preventDefault();
    if (!this.state.auctionId || !this.state.videoFile) {
      swal("Failed", "File Missing", "error");
      return;
    }

    this.setState({ is_loading_video: true });
    const formData = new FormData();
    formData.append("auction_id", this.state.auctionId);
    if (this.state.videoFile) {
      formData.append(
        "videoFile",
        this.state.videoFile,
        this.state.videoFile.name
      );
    }
    const response = await uploadVideo(formData);
    if (response) {
      this.setState({ is_loading_video: false });
      if (response.success) {
        this.setState({ auction: response.data });
      } else {
        swal(
          "Failed",
          "Some error occured!! Please make sure that you are uploading video file.",
          "error"
        );
      }
    }
  }

  async uploadImage(event) {
    event.preventDefault();
    let images = this.state.imageFiles;
    if (!this.state.auctionId || !images.length) {
      swal("Failed", "File Missing", "error");
      return;
    }
    this.setState({ is_loading_images: true });
    const formData = new FormData();
    formData.append("auction_id", this.state.auctionId);
    if (images.length) {
      for (let i = 0; i < images.length; i++) {
        formData.append("imageFiles[]", images[i]);
      }
    }
    const response = await uploadImage(formData);
    if (response.success) {
      this.setState({ is_loading_images: false });
      this.loadAllImages();
    } else {
      swal(
        "Failed",
        "Please make sure the file formats before uploading.",
        "error"
      );
    }
  }

  async removeImage(id) {
    const response = await removeImage({
      image_id: id,
      auction: this.state.auctionId,
    });
    if (response.success) {
      this.loadAllImages();
    }
  }

  async makeCover(id) {
    const response = await makeCover({
      image_id: id,
      auction: this.state.auctionId,
    });
    if (response.success) {
      this.loadAllImages();
    }
  }

  render() {
    let images = this.state.images;
    let video = this.state.auction.video;

    return (
      <React.Fragment>
        <HeaderBanner
          title={i18n.t("media_files")}
          subtitle={i18n.t("upload_media_subtitle") || "Manage auction images and video"}
        />
        <section className="dashboard-section">
          <div className="container">
            <div className="row">
              <div className="col-xl-3 col-lg-12 col-md-12">
                {!this.state.hideSidebar && <SideBar />}
              </div>
              <div
                className={
                  this.state.hideSidebar
                    ? "col-xl-12 col-lg-12 col-md-12"
                    : "col-xl-9 col-lg-12 col-md-12"
                }
              >
                <div className="card">
                  <div className="card-header">
                    <div className="expand-dashboard">
                      <span
                        style={{
                          fontSize: "1rem",
                          marginRight: "0.5rem",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          this.setState({
                            hideSidebar: !this.state.hideSidebar,
                          })
                        }
                      >
                        {this.state.hideSidebar && <Shrink strokeWidth={1} />}
                        {!this.state.hideSidebar && <Expand strokeWidth={1} />}
                      </span>
                    </div>
                    <div className="header-action">
                      <button
                        className="button1 button1-gradient button1-back"
                        onClick={() => window.history.back()}
                      >
                        <ArrowLeft size={18} className="icon" />
                        <span>{i18n.t("back")}</span>
                      </button>
                    </div>
                  </div>
                  <div className="card-body">
                    <AuctionTabs activeTab="uploader" />
                    <div className="create-group-container">
                      <div className="form-content">
                        {/* LEFT COLUMN - Images */}
                        <div className="left-column">
                          <div className="form-section">
                            <div className="section-header">
                              <h2>
                                <Image
                                  size={20}
                                  strokeWidth={1.5}
                                  style={{ marginRight: "8px" }}
                                />
                                {i18n.t("media_files")}
                              </h2>
                            </div>
                            <p
                              style={{
                                fontSize: "0.85rem",
                                color: "#6b7280",
                                marginBottom: "16px",
                              }}
                            >
                              {i18n.t("allowed_formats")}: .jpg, .jpeg, .png,
                              .gif, .bmp
                            </p>

                            {/* Upload Area */}
                            <div className="upload-field">
                              <label>{i18n.t("upload_images") || "Upload Images"}</label>
                              <div className="upload-area">
                                <FileInput
                                  wrapperClass=""
                                  placeholder={i18n.t("choose_file")}
                                  id="imageFiles"
                                  name="imageFiles"
                                  onChange={this.onFileChange}
                                  className="form-control"
                                  multiple={true}
                                />
                              </div>
                              <button
                                className="button1 button1-primary"
                                onClick={this.uploadImage}
                                type="button"
                                style={{ marginTop: "12px" }}
                              >
                                <Cloud size={18} style={{ marginRight: "6px" }} />
                                {i18n.t("upload")}
                              </button>
                            </div>

                            {/* Loading State */}
                            {this.state.is_loading_images && (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  padding: "3rem",
                                  background: "#f9fafb",
                                  borderRadius: "8px",
                                  marginTop: "16px",
                                }}
                              >
                                <Loader2
                                  className="animate-spin"
                                  size={24}
                                  style={{ marginRight: "8px" }}
                                />
                                <span>{i18n.t("loading") || "Loading..."}</span>
                              </div>
                            )}

                            {/* Image Grid */}
                            {!this.state.is_loading_images &&
                              images &&
                              images.length > 0 && (
                                <div
                                  style={{
                                    display: "grid",
                                    gridTemplateColumns:
                                      "repeat(auto-fill, minmax(200px, 1fr))",
                                    gap: "16px",
                                    marginTop: "20px",
                                  }}
                                >
                                  {images.map((item, i) => (
                                    <div
                                      key={i}
                                      style={{
                                        position: "relative",
                                        borderRadius: "8px",
                                        overflow: "hidden",
                                        border: "1px solid #e5e7eb",
                                        background: "#fff",
                                      }}
                                    >
                                      {item.is_cover === 1 && (
                                        <div
                                          style={{
                                            position: "absolute",
                                            top: "8px",
                                            left: "8px",
                                            background: "#f59e0b",
                                            color: "#fff",
                                            padding: "2px 8px",
                                            borderRadius: "4px",
                                            fontSize: "0.75rem",
                                            fontWeight: "600",
                                            zIndex: 2,
                                            display: "flex",
                                            alignItems: "center",
                                            gap: "4px",
                                          }}
                                        >
                                          <Star size={12} />
                                          {i18n.t("cover")}
                                        </div>
                                      )}
                                      <img
                                        src={item.image}
                                        alt=""
                                        style={{
                                          width: "100%",
                                          height: "160px",
                                          objectFit: "cover",
                                        }}
                                      />
                                      <div
                                        style={{
                                          display: "flex",
                                          gap: "4px",
                                          padding: "8px",
                                          justifyContent: "center",
                                        }}
                                      >
                                        <a
                                          href={item.image}
                                          target="_blank"
                                          rel="noreferrer"
                                          className="button1 button1-secondary"
                                          style={{
                                            padding: "4px 10px",
                                            fontSize: "0.8rem",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            gap: "4px",
                                            textDecoration: "none",
                                          }}
                                        >
                                          <Eye size={14} />
                                          {i18n.t("view")}
                                        </a>
                                        <button
                                          type="button"
                                          className="button1 button1-secondary"
                                          style={{
                                            padding: "4px 10px",
                                            fontSize: "0.8rem",
                                          }}
                                          onClick={() => {
                                            this.makeCover(item.id);
                                          }}
                                        >
                                          <Star size={14} />
                                          {i18n.t("make_cover")}
                                        </button>
                                        <button
                                          type="button"
                                          className="button1 button1-danger"
                                          style={{
                                            padding: "4px 10px",
                                            fontSize: "0.8rem",
                                          }}
                                          onClick={() => {
                                            this.removeImage(item.id);
                                          }}
                                        >
                                          <Trash2 size={14} />
                                          {i18n.t("delete")}
                                        </button>
                                      </div>
                                    </div>
                                  ))}
                                </div>
                              )}
                          </div>
                        </div>

                        {/* RIGHT COLUMN - Video */}
                        <div className="right-column">
                          <div className="form-section">
                            <div className="section-header">
                              <h2>
                                <Video
                                  size={20}
                                  strokeWidth={1.5}
                                  style={{ marginRight: "8px" }}
                                />
                                {i18n.t("video")}
                              </h2>
                            </div>
                            <p
                              style={{
                                fontSize: "0.85rem",
                                color: "#6b7280",
                                marginBottom: "16px",
                              }}
                            >
                              {i18n.t("allowed_formats")}:
                              mp4, ogx, oga, ogv, ogg, webm
                            </p>

                            {/* Video Upload Area */}
                            <div className="upload-field">
                              <label>{i18n.t("upload_video") || "Upload Video"}</label>
                              <div className="upload-area">
                                <FileInput
                                  wrapperClass=""
                                  placeholder={i18n.t("choose_file")}
                                  id="videoFile"
                                  name="videoFile"
                                  onChange={this.onFileChange}
                                  className="form-control"
                                />
                              </div>
                              <button
                                className="button1 button1-primary"
                                onClick={this.uploadVideo}
                                type="button"
                                style={{ marginTop: "12px" }}
                              >
                                <Cloud size={18} style={{ marginRight: "6px" }} />
                                {i18n.t("upload")}
                              </button>
                            </div>

                            {/* Loading State */}
                            {this.state.is_loading_video && (
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  padding: "3rem",
                                  background: "#f9fafb",
                                  borderRadius: "8px",
                                  marginTop: "16px",
                                }}
                              >
                                <Loader2
                                  className="animate-spin"
                                  size={24}
                                  style={{ marginRight: "8px" }}
                                />
                                <span>{i18n.t("loading") || "Loading..."}</span>
                              </div>
                            )}

                            {/* Video Preview */}
                            {!this.state.is_loading_video && video && (
                              <div
                                style={{
                                  marginTop: "20px",
                                  borderRadius: "8px",
                                  overflow: "hidden",
                                  border: "1px solid #e5e7eb",
                                }}
                              >
                                <video
                                  controls
                                  style={{
                                    width: "100%",
                                    height: "auto",
                                    display: "block",
                                  }}
                                >
                                  <source src={video} type="video/mp4" />
                                  Your browser does not support HTML video.
                                </video>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </React.Fragment>
    );
  }
}